<template>
  <router-view></router-view>
  <!-- nginx sends /new-version to the new portal (its own port) -->
  <a href="/new-version" class="new-version-btn">New version</a>
</template>

<script>
export default {
  name: "App"
}
</script>

<style>
.new-version-btn {
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 1040;
  padding: 10px 18px;
  border-radius: 999px;
  border: 2px solid #fff;
  background: #2346c8;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none !important;
  box-shadow: 0 6px 18px rgba(35, 70, 200, 0.35);
}
.new-version-btn:hover {
  background: #1a3596;
}
</style>
